import { NavLink, Link } from "react-router-dom";
import { useState, useEffect } from "react";

import "./header.css";

import logo from "../assets/img/logo_256.webp";

function Header() {
    const [isOpen, setIsOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => {
            setIsScrolled(window.scrollY > 100);
        };

        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return <>
        <div className={`header ${isScrolled ? "shrink" : ""}`}>

            <Link className="logo" to="/" onClick={() => setIsOpen(false)}>
                <img src={logo}/>
            </Link>

            <p>
                <div>Tanz- und Bewegungstherapie</div>
                {<div className="shrink-remove">Psychotherapeutische Praxis (HeilprG)</div>}
            </p>
            <h1>Solveig Marita Bissinger</h1>

            <button className={`${isOpen ? "burger open" : "burger"}`} onClick={() => setIsOpen(!isOpen)}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 31">
                    <rect x="0" y="0" width="40" height="3" fill="black" />
                    <rect x="0" y="14" width="40" height="3" fill="black" />
                    <rect x="0" y="28" width="40" height="3" fill="black" />
                </svg>
            </button>

            <nav className={`${isOpen ? "open" : ""}`}>
                
                <NavLink exact to="/" onClick={() => setIsOpen(false)}>Home</NavLink>
                <NavLink to="/tanztherapie" onClick={() => setIsOpen(false)}>Tanztherapie</NavLink>
                <a href="https://solveig-bissinger.de" target="_blank" rel="noopener noreferrer">
                Kreativer Tanz
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" height="19" viewBox="0 0 24 24" ver>
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 14v4.833A1.166 1.166 0 0 1 16.833 20H5.167A1.167 1.167 0 0 1 4 18.833V7.167A1.166 1.166 0 0 1 5.167 6h4.618m4.447-2H20v5.768m-7.889 2.121 7.778-7.778"/>
                </svg>
                </a>
                <NavLink to="/ueber" onClick={() => setIsOpen(false)}>Über Mich</NavLink>
                <NavLink to="/links" onClick={() => setIsOpen(false)}>Links & Hilfsangebote</NavLink>
                <NavLink to="/kontakt" onClick={() => setIsOpen(false)}>Kontakt</NavLink>

            </nav>
        </div>

        <div id="nav-out" className={`${isOpen ? "open" : ""}`} onClick={() => setIsOpen(!isOpen)}/>
    </>
}

export default Header;